import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
/* empty css                */
const RowTrigger = ({
  title,
  className,
  "data-t": dataT,
  onClick
}) => {
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      "data-t": dataT,
      "aria-label": title,
      className: classnames("row-trigger", className),
      onClick
    },
    /* @__PURE__ */ React.createElement(
      Heading,
      {
        component: "h2",
        variant: "smallest",
        className: classnames("row-trigger__heading", className)
      },
      title
    ),
    /* @__PURE__ */ React.createElement(Icon, { name: "chevron-right", className: "row-trigger__link-icon" })
  );
};
export {
  RowTrigger,
  RowTrigger as default
};
//# sourceMappingURL=RowTrigger.js.map
